import type { LoyaltyProgram } from '@voll-intelligence/domain';
import type { LoyaltyPlan } from '../port.js';

/** Uma entrada da linha de fidelidade: o programa e o número do perfil, ou
 *  `null` sem ele. */
export interface LoyaltyEntry {
  program: LoyaltyProgram;
  number: string | null;
}

/** Casa cada programa do card com o perfil, pelo programa (nunca pelo código
 *  cru: a linha gravada com «JJ» já chega como `latam-pass`). */
export function loyaltyEntries(
  programs: readonly LoyaltyProgram[],
  plans: readonly LoyaltyPlan[],
): LoyaltyEntry[] {
  return programs.map((program) => ({
    program,
    number: plans.find((plan) => plan.programId === program.id)?.number ?? null,
  }));
}

/** «•••• 1234»: só os quatro últimos caracteres do número. */
export function maskLoyaltyNumber(number: string): string {
  return `•••• ${number.trim().slice(-4)}`;
}
